module.exports = __webpack_public_path__ + "braveuistatic/img/apps/www.bravenet.com/src/assets/img/sitebuilder/templates/bravenet_siteblocks_welcome.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.bravenet.com/src/assets/img/sitebuilder/templates/bravenet_siteblocks_welcome.png
// module id = gYr5
// module chunks = 0